import {Component, OnInit} from '@angular/core';
import {ActivatedRoute, Router} from '@angular/router';
import {Helper} from '../../../../helpers/helper.service';
import {TranslateService} from '@ngx-translate/core';
import {Country} from '../../../Models/Country';
import {CountryService} from '../../../../translation/Services/Country.service';
import {Vat} from '../../../Models/Vat';
import {DealerRole} from '../../../../dealer-system/Models/DealerRole';

@Component({
  selector: 'app-manage-country',
  templateUrl: './manage-country.component.html',
  styleUrls: ['./manage-country.component.scss']
})
export class ManageCountryComponent implements OnInit {
  public isEdit = false;
  public country = new Country();
  public countryId: number;
  public dateFormatOptions: any[] | boolean = [];
  public currencyFormatOptions: any[] | boolean = [];
  public currencyDecimalsOptions: any[];

  constructor(
    private route: ActivatedRoute,
    public helper: Helper,
    private translate: TranslateService,
    private router: Router,
    private countryService: CountryService
  ) {
  }

  ngOnInit() {
    this.countryService.listDateFormats().subscribe((res) => {
      this.dateFormatOptions = res;
      this.country.dateFormat = res[0];
    });
    this.countryService.listCurrencyFormats().subscribe((res) => {
      this.currencyFormatOptions = res;
      this.country.currencyFormat = res[0];
    });
    this.currencyDecimalsOptions = [
      0, 1, 2
    ];
    this.route.params.subscribe(params => {
      if (Helper.isDefined(params['id'])) {
        this.countryId = params['id'];
        this.isEdit = true;
        this.countryService.getCountryById(this.countryId).subscribe(resp => {
          this.country = resp;
        });
      }
    });
  }

  saveCountry() {
    if (this.country.id) {
      delete this.country.id;
    }
    delete this.country.thousandSeparator;
    delete this.country.decimalSeparator;
    delete this.country.userDateFormat;
    this.countryService.manageCountry(this.country, this.isEdit, this.countryId).subscribe(res => {
      this.router.navigateByUrl('/back-office/country/overview');
    });
  }

  public backToList() {
    this.router.navigateByUrl('/back-office/country/overview');
  }
}
